module.exports = __webpack_public_path__ + "static/media/aold.9c23f030.jpg";